<form [formGroup]="faxForm">
  <!-- Radio -->
  @if (!isPdp) {
    <div class="field">
      <label>Provider Type:</label>
      <div class="flex gap-4">
        <div class="flex items-center">
          <p-radio-button data-test-id="service-facility-radio-button" formControlName="providerType"
            inputId="providerTypeService" name="providerType" [value]="providerTypes.service" />
          <label class="ml-2" for="providerTypeService">{{ serviceProviderLabel }}</label>
        </div>
        <div class="flex items-center">
          <p-radio-button data-test-id="referral-provider-radio-button" formControlName="providerType" inputId="providerTypeOrder" name="providerType"
            [value]="providerTypes.order" />
          <label class="ml-2" for="providerTypeOrder">{{ orderingProviderLabel }}</label>
        </div>
          </div>
        </div>
      }

      <p-fluid>
      <div class="grid grid-cols-12 gap-4">
        <div class="md:col-span-6 col-span-12 field mb-0">
          <label class="field-required" data-test-id="recipient-name-label">To:</label>
          <input data-test-id="recipient-name-input" formControlName="recipientName" maxlength="250" pInputText type="text">
          <app-errors-messages [control]="faxForm.get('recipientName')" />
        </div>

        <div class="md:col-span-6 col-span-12 field">
          <label class="field-required" data-test-id="provider-location-label">Provider Location:</label>
          <input data-test-id="provider-location-input" formControlName="providerLocation" maxlength="100" pInputText
            type="text">
            <app-errors-messages [control]="faxForm.get('providerLocation')" />
          </div>
          <div class="md:col-span-6 col-span-12 field mb-0">
            <label class="field-required" data-test-id="subject-label">Subject:</label>
            <div class="flex flex-row gap-2">
              @if (!subject) {
                <p-selectButton formControlName="subjectOption"  optionLabel="label" optionValue="value"
                  styleClass="p-buttonset-custom" [options]="subjectOptions" (onChange)="subjectSelection($event)">
                </p-selectButton>
              }
              <label class="field" data-test-id="recipient-name-label"> {{subject}}</label>
            </div>
          </div>
          <div class="md:col-span-6 col-span-12 field">
            <label class="field-required" data-test-id="recipient-fax-number-label">Provider Fax Number:</label>
            <p-input-mask data-test-id="recipient-fax-number-input" formControlName="recipientFaxNumber" mask="(999) 999-9999"
              [unmask]="true">
            </p-input-mask>

            <app-errors-messages [control]="faxForm.get('recipientFaxNumber')" />
          </div>
          @if (isOther) {
            <div class="md:col-span-6 col-span-12 field mb-0">
              <label class="field-required" data-test-id="subject-label">Other-Subject:</label>
              <input data-test-id="subject-input" formControlName="subject" maxlength="100" pInputText type="textarea">
              <app-errors-messages [control]="faxForm.get('subject')" />
            </div>
          }
        </div>
      </p-fluid>
      </form>
